import type { usePatientSummaries } from '@ctw/shared/content/summarization/use-patient-summaries';
import { type PropsWithChildren, createContext, useContext } from 'react';

interface PatientSummaryJobState extends PropsWithChildren {
  summaryResponse: ReturnType<typeof usePatientSummaries>;
}

const PatientSummaryJobContext = createContext<PatientSummaryJobState | null>(null);

interface PatientSummaryJobProviderProps extends PropsWithChildren {
  summaryResponse: ReturnType<typeof usePatientSummaries>;
}

export const PatientSummaryJobProvider = ({
  summaryResponse,
  children,
}: PatientSummaryJobProviderProps) => {
  return (
    <PatientSummaryJobContext.Provider value={{ summaryResponse }}>
      {children}
    </PatientSummaryJobContext.Provider>
  );
};

export function usePatientSummaryJob() {
  const context = useContext(PatientSummaryJobContext);

  if (!context) {
    throw new Error(
      'usePatientSummaryJob must be used within a PatientProvider or PatientSummaryJobProvider',
    );
  }

  return context;
}
